import styles from "./TheTableWrapper.module.css"
const TheTableWrapper = ({ children }) => {
    return <div className={styles.tableWrapperContainer}>{children}</div>;
}

export default TheTableWrapper;